import React from 'react'
import {Trans as BaseTrans} from 'react-i18next'
import i18n from 'i18next'

const Trans: typeof BaseTrans = (props) => <BaseTrans i18n={i18n} {...props} />

export default Trans
